import React from "react";
import MainPagePresenter from "./MainPagePresenter";
import Menu from "../../components/Menu";
// import { Menu } from "../../nq-component";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route, useLocation } from "react-router-dom";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, Progress, LogoHolder } from "../../nq-component";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
import DashboardPage from "../dashboard/DashboardPage";
import menus from "./menus.json";
import MenuX from "../../components/MenuX";
import LogoutModal from "./components/LogoutModal";
import MonthsListPage from "../months/MonthsListPage";
import ReceiptsListPage from "../receipts/list/ReceiptsListPage";
import SuppliersListPage from "../suppliers/list/SuppliersListPage";
import SuppliersFormPage from "../suppliers/form/SuppliersFormPage";
import FlexibleEntryFormPage from "../receipts/form/FlexibleEntry/FlexibleEntryFormPage";
import ByDateFormPage from "../receipts/form/BatchByDate/ByDateFormPage";
import BySupplierFormPage from "../receipts/form/GroupedBySupplier/BySupplierFormPage";
import OffCanvas from "../../components/OffCanvas";
import SalesListPage from "../sales/list/SalesListPage";
import ClientsListPage from "../clients-page/list/ClientsListPage";
import ClientsFormPage from "../clients-page/form/ClientsFormPage";
import ReportsListPage from "../reports/ReportsListPage";
import EmployeesListPage from "../employees/list/EmployeesListPage";
import EmployeesFormPage from "../employees/form/EmployeesFormPage";
import ProtectedRoute from "../../components/ProtectedRoute";
import NavSideBar from "../../components/NavSideBar";
import AuditListPage from "../audit-pages/list/AuditListPage";
import BankListPage from "../bank/list/BankListPage";
import BankFormPage from "../bank/form/BankFormPage";
import SettingsPage from "../settings/SettingsPage";
import SystemSettingsPage from "../settings/SystemSettingsPage";
import ProfileStandalonePage from "../profile/ProfileStandalonePage";
import NotificationsStandalonePage from "../notification/NotificationsStandalonePage";
import NavBar from "../../components/navbar";
import { findObjectUseCase } from "../../usecases/object";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase(),
      findObjectUseCase(),
    );
    this.state = {
      signout: false,
      notifications: [],
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount?.();
    clearInterval(this.timeInterval);
    clearInterval(this.interval);
    if (this.presenter) {
      this.presenter.stopPolling();
    }
  }

  onClickSignOut() {
    // this.presenter.onClickSignOut();
    this.presenter.signout();
  }

  openSignOutModal() {
    this.setState({ signout: true });
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  filterAccess(menus, roles) {
    return menus?.filter((menu) => {
      if (Array.isArray(menu.route)) {
        menu.route = this.filterAccess(menu.route, roles);
      }
      if (!menu.access) {
        return true;
      }
      if (roles.some((role) => menu.access.includes(role?.id))) {
        return true;
      }
      return false;
    });
  }

  renderRoutes(user, roles) {
    return (
      <>
        <Route
          element={
            <ProtectedRoute
              user={user}
              roles={roles}
              allowedRoles={["Client"]}
            />
          }
        >
          <Route exact path={"/"} element={<DashboardPage />} />
          <Route
            exact
            path={"/collection/:name"}
            element={<CollectionListPage />}
          />
          <Route path={"/roles/form"} element={<RoleFormPage />} />
          <Route path={"/roles/form/:id"} element={<RoleFormPage />} />
          <Route
            path={"/collection/:name/form/"}
            element={<CollectionFormPage />}
          />
          <Route
            path={"/collection/:name/form/:id"}
            element={<CollectionFormPage />}
          />
          <Route path={"/purchases"} element={<MonthsListPage />} />
          <Route path={"/suppliers"} element={<SuppliersListPage />} />
          <Route
            path={"/purchases/:month/:year"}
            element={<ReceiptsListPage />}
          />
          <Route path={"/suppliers/form"} element={<SuppliersFormPage />} />
          <Route path={"/suppliers/form/:id"} element={<SuppliersFormPage />} />
          <Route
            path={"/purchases/form/flexible_entry/:month/:year"}
            element={<FlexibleEntryFormPage />}
          />
          <Route
            path={"/purchases/form/by_date/:month/:year"}
            element={<ByDateFormPage />}
          />
          <Route
            path={"/purchases/form/by_supplier/:month/:year"}
            element={<BySupplierFormPage />}
          />
          <Route path={"/sales"} element={<SalesListPage />} />
          <Route path={"/months/:collection"} element={<MonthsListPage />} />
          <Route path={"/sales/:month/:year"} element={<SalesListPage />} />
          <Route path={"/employees"} element={<EmployeesListPage />} />
          <Route path={"/employees/form"} element={<EmployeesFormPage />} />
          <Route path={"/employees/form/:id"} element={<EmployeesFormPage />} />
          <Route path={"/bank-accounts"} element={<BankListPage />} />
          <Route path={"/bank-account/form"} element={<BankFormPage />} />
          <Route path={"/bank-account/form/:id"} element={<BankFormPage />} />
        </Route>

        {/*ADMIN ACCESS*/}
        <Route
          element={
            <ProtectedRoute
              user={user}
              roles={roles}
              allowedRoles={["Admin"]}
            />
          }
        >
          <Route path={"/dashboard/:id"} element={<DashboardPage />} />

          {/*Admin Sales Route*/}
          <Route path={"/sales/:month/:year/:id"} element={<SalesListPage />} />

          {/*Admin Receipts/Purchases Route*/}
          <Route
            path={"/purchases/:month/:year/:clientId"}
            element={<ReceiptsListPage />}
          />
          <Route
            path={"/purchases/form/flexible_entry/:month/:year/:clientId"}
            element={<FlexibleEntryFormPage />}
          />
          <Route
            path={"/purchases/form/by_date/:month/:year/:clientId"}
            element={<ByDateFormPage />}
          />
          <Route
            path={"/purchases/form/by_supplier/:month/:year/:clientId"}
            element={<BySupplierFormPage />}
          />
          <Route path={"/reports/:id"} element={<ReportsListPage />} />
          <Route path={"/audit/:collection"} element={<AuditListPage />} />
          <Route
            path={"/employees/form-input/:clientId"}
            element={<EmployeesFormPage />}
          />
          <Route
            path={"/employees/form/:id/:clientId"}
            element={<EmployeesFormPage />}
          />
          <Route
            path={"/employees/:clientId"}
            element={<EmployeesListPage />}
          />
          <Route
            path={"/clients/list/:clientId"}
            element={<ClientsListPage />}
          />

          <Route
            path={"/clients/form-client/:type/:clientId"}
            element={<ClientsFormPage />}
          />
          <Route path={"/reports"} element={<ReportsListPage />} />
          <Route path={"/settings/system"} element={<SystemSettingsPage />} />
        </Route>

        <Route path={"/settings"} element={<SettingsPage />} />
        <Route path={"/profile"} element={<ProfileStandalonePage />} />
        <Route
          path={"/notifications"}
          element={<NotificationsStandalonePage />}
        />
        <Route path={"/clients"} element={<ClientsListPage />} />
        <Route path={"/clients/form"} element={<ClientsFormPage />} />
        <Route path={"/clients/form/:id"} element={<ClientsFormPage />} />
        <Route
          path={"/clients/form-input/:type"}
          element={<ClientsFormPage />}
        />
        <Route path={"/clients/form-input"} element={<ClientsFormPage />} />
        <Route path={"/expired"} element={<NotFoundPage />} />
      </>
    );
  }
  render() {
    const { signout, notifications } = this.state;
    const { pathname } = this.props.location;
    const user = this.getCurrentUser();
    const schemas = this.getSchemas();
    const roles = this.getCurrentRoles();
    if (user === undefined || schemas === undefined) {
      return (
        <div className="d-flex vh-100 justify-content-center align-align-items-center">
          <Progress />
        </div>
      );
    }

    const access = this.filterAccess(menus, roles);
    return (
      <Layout>
        <Layout.Context.Consumer>
          {(value) => (
            <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
              <NavSideBar
                onClickMenu={this.onClickMenu.bind(this)}
                onSignOut={this.openSignOutModal.bind(this)}
                user={user}
                access={access}
              />
            </OffCanvas>
          )}
        </Layout.Context.Consumer>
        <main
          className="vh-100 d-flex flex-column"
          style={{ backgroundColor: "#f4f4f4" }}
        >
          <NavBar
            user={user}
            notifs={notifications}
            onViewAll={() => this.navigateTo("/notifications")}
            onClickProfile={() => this.navigateTo("/settings")}
            onClickSettings={() => this.navigateTo("/settings/system")}
          />
          <Routes>{this.renderRoutes(user, roles)}</Routes>
        </main>
        <LogoutModal
          isOpen={signout}
          onCancel={() => this.setState({ signout: false })}
          onProceed={this.onClickSignOut.bind(this)}
        />
      </Layout>
    );
  }
}

const MainPageWithLocation = (props) => {
  const location = useLocation();
  return <MainPage {...props} location={location} />;
};

export default withRouter(MainPageWithLocation);
